const GenderOptions = () => [
  { label: 'Laki-laki', value: 'Male' },
  { label: 'Perempuan', value: 'Female' },
]

export default GenderOptions